import { render, staticRenderFns } from "./CustomSemiCircle.vue?vue&type=template&id=6c9080d8"
import script from "./CustomSemiCircle.vue?vue&type=script&lang=js"
export * from "./CustomSemiCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports